import { isHighlightableStringExpandableContainer } from '@/app/log-viewer/highlighting/HighlightableStringExpandableContainer';

export function shouldCopyInsteadOfMergeForKey(args: { key: string; source: any }): boolean {
  // NetworkRequestBodyModelData and NetworkBodyWithJqCellModelData.
  // If has complete jq result - then just copy it.
  return (
    args.key === 'processedJqResult' &&
    typeof args.source !== 'undefined' &&
    typeof args.source.jqQuery !== 'undefined' &&
    typeof args.source.processedHighlightableJson !== 'undefined' &&
    isHighlightableStringExpandableContainer(args.source.processedHighlightableJson)
  );
}
